export default function HeroSection() {
  return (
    <section
      id="hero"
      className="relative min-h-screen flex items-center pt-[72px] overflow-hidden bg-background-50"
    >
      <div className="absolute inset-0 bg-gradient-to-br from-primary-50/60 via-background-50 to-accent-50/40"></div>
      <div className="absolute top-20 right-0 w-[600px] h-[600px] bg-primary-100/30 rounded-full blur-3xl"></div>
      <div className="absolute bottom-10 left-10 w-[400px] h-[400px] bg-accent-100/25 rounded-full blur-3xl"></div>

      <div className="relative w-full max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <span className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-primary-100 text-primary-700 text-xs font-semibold mb-5 whitespace-nowrap">
              <i className="ri-fire-line"></i> 实时更新 · 每日新鲜
            </span>

            <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-extrabold text-foreground-950 leading-tight">
              51吃瓜爆料网
              <br />
              <span className="text-primary-500">全网最热吃瓜短视频聚集地</span>
            </h1>

            <p className="mt-3 text-base md:text-lg text-foreground-600 font-medium">
              台北娜娜 · 玩偶姐姐 · 莫里秀 热梗一网打尽
            </p>

            <p className="mt-5 text-sm md:text-base text-foreground-600 leading-relaxed max-w-xl mx-auto lg:mx-0">
              51吃瓜爆料网专注整理台北娜娜、玩偶姐姐、莫里秀等网红热梗合集，提供轻量版吃瓜短视频，直击吃瓜娱乐现场与网红直播翻车片段。
              每日筛选全网最新最热的搞笑吃瓜瞬间，让你不错过任何一个名场面。从吃瓜真人秀片段到网红翻车合集，一站看齐。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-5 md:gap-8 mt-7">
              <div className="text-center">
                <div className="text-xl md:text-2xl font-extrabold text-accent-500">200+</div>
                <div className="text-xs text-foreground-500 mt-1">日更新内容</div>
              </div>
              <div className="w-px h-8 bg-background-300 hidden sm:block"></div>
              <div className="text-center">
                <div className="text-xl md:text-2xl font-extrabold text-accent-500">300+</div>
                <div className="text-xs text-foreground-500 mt-1">覆盖网红达人</div>
              </div>
              <div className="w-px h-8 bg-background-300 hidden sm:block"></div>
              <div className="text-center">
                <div className="text-xl md:text-2xl font-extrabold text-accent-500">千万级</div>
                <div className="text-xs text-foreground-500 mt-1">用户在看</div>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3 mt-8">
              <a
                href="#carousel"
                onClick={(e) => {
                  e.preventDefault();
                  document.querySelector('#carousel')?.scrollIntoView({ behavior: 'smooth' });
                }}
                className="w-full sm:w-auto px-8 py-3.5 bg-primary-500 text-background-50 font-semibold rounded-full hover:bg-primary-600 transition-all text-sm whitespace-nowrap cursor-pointer text-center"
              >
                <i className="ri-flashlight-line mr-2"></i>立即吃瓜
              </a>
              <a
                href="#contact"
                onClick={(e) => {
                  e.preventDefault();
                  document.querySelector('#contact')?.scrollIntoView({ behavior: 'smooth' });
                }}
                className="w-full sm:w-auto px-8 py-3.5 bg-background-100 text-foreground-700 font-medium rounded-full hover:bg-background-200 transition-all text-sm border border-background-300 whitespace-nowrap cursor-pointer text-center"
              >
                <i className="ri-send-plane-line mr-2"></i>投稿爆料
              </a>
            </div>
          </div>

          <div className="flex-1 w-full flex justify-center lg:justify-end">
            <div className="relative w-full max-w-[480px] aspect-[4/3] rounded-2xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Vibrant%20abstract%20digital%20art%20with%20warm%20coral%20and%20amber%20gradients%2C%20playful%20dynamic%20shapes%20representing%20social%20media%20entertainment%20and%20gossip%20culture%2C%20Chinese%20internet%20meme%20aesthetic%2C%20glowing%20orbs%20and%20flowing%20ribbons%2C%20modern%20youth%20culture%20abstract%20composition%2C%20soft%20light%20leaks%2C%20energetic%20contemporary%20design%20with%20a%20sense%20of%20excitement%20and%20buzz&width=960&height=720&seq=hero-main-2026&orientation=landscape"
                alt="51吃瓜爆料网 — 热播吃瓜短视频聚集地"
                className="w-full h-full object-cover rounded-2xl"
              />
              <div className="absolute inset-0 bg-gradient-to-tr from-primary-500/10 to-transparent rounded-2xl"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}